/**
 * GSAP — easing projet (courbe douce ease-out cubic) + defaults globaux.
 * - CustomEase nommé `easeSoft` (SVG path ≈ cubic-bezier(0.215, 0.61, 0.355, 1)).
 * - `window.GSAP_EASE_SOFT` : chaîne à passer aux tweens (ex. `'easeSoft'` ou `'power2.out'` si pas CustomEase).
 * - `window.GSAP_BG_SCALE_FROM` : lecture de `--gsap-fullpage-bg-scale-from` (:root dans css-variables.liquid).
 * - `gsap.defaults({ ease, duration })` : les tweens sans ease/duration héritent de ces valeurs.
 * Chargé synchrone après CustomEase dans theme.liquid (après critical.css ; avant les scripts defer).
 * CSS : même courbe via `var(--ease-soft)` dans style-theme.css (@theme).
 */
(function () {
  /**
   * Même valeur que le scale initial `.js-fullpage-bg` desktop (critical.css).
   */
  function readBgScaleFrom() {
    if (typeof document === 'undefined') return 1.3;
    var raw =
      getComputedStyle(document.documentElement).getPropertyValue('--gsap-fullpage-bg-scale-from').trim();
    var n = parseFloat(raw.replace(',', '.'));
    return typeof n === 'number' && n > 0 && !isNaN(n) ? n : 1.3;
  }

  window.GSAP_BG_SCALE_FROM = readBgScaleFrom();

  if (typeof gsap === 'undefined') return;

  var easeName = 'power2.out';
  if (typeof CustomEase !== 'undefined') {
    CustomEase.create('easeSoft', 'M0,0 C0.215,0.61 0.355,1 1,1');
    easeName = 'easeSoft';
  }

  window.GSAP_EASE_SOFT = easeName;
  gsap.defaults({ ease: easeName, duration: 0.65 });
})();
